var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarNoResult = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 31,
  height: 30,
  viewBox: "0 0 31 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.407 17.248L23.3694 21.2104L21.742 22.8965L17.75 18.9051L19.407 17.248Z",
  fill: "#D9D1EF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.02344 11.4844C2.02344 5.98301 6.48301 1.52344 11.9844 1.52344C17.4857 1.52344 21.9453 5.98301 21.9453 11.4844C21.9453 16.9848 17.4867 21.4453 11.9844 21.4453C6.48301 21.4453 2.02344 16.9857 2.02344 11.4844Z",
  fill: "#C9B6FF"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.95312 11.4844C4.95313 7.60137 8.10137 4.45312 11.9844 4.45312C15.8674 4.45312 19.0156 7.60137 19.0156 11.4844C19.0156 15.3674 15.8674 18.5156 11.9844 18.5156C8.10137 18.5156 4.95312 15.3674 4.95312 11.4844Z",
  fill: "#F0EBFD"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.3286 8.16992L11.5719 9.41316C11.8007 9.64197 12.1717 9.64197 12.4005 9.41316L13.6438 8.16992C13.8726 7.94111 14.2436 7.94111 14.4724 8.16992L15.3008 8.99832C15.5296 9.22712 15.5296 9.59814 15.3008 9.82695L14.0575 11.0702C13.8287 11.299 13.8287 11.67 14.0575 11.8988L15.3008 13.1421C15.5296 13.3709 15.5296 13.7419 15.3008 13.9707L14.4724 14.7991C14.2436 15.0279 13.8726 15.0279 13.6438 14.7991L12.4005 13.5559C12.1717 13.327 11.8007 13.327 11.5719 13.5559L10.3286 14.7991C10.0998 15.0279 9.72881 15.0279 9.5 14.7991L8.67161 13.9707C8.4428 13.7419 8.4428 13.3709 8.67161 13.1421L9.91485 11.8988C10.1437 11.67 10.1437 11.299 9.91485 11.0702L8.67161 9.82695C8.4428 9.59814 8.4428 9.22712 8.67161 8.99832L9.5 8.16992C9.72881 7.94111 10.0998 7.94111 10.3286 8.16992Z",
  fill: "#A98AFF"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3176 20.3319C23.5464 20.1031 23.9174 20.1031 24.1463 20.332L28.2894 24.4756C29.2052 25.3909 29.2052 26.8745 28.2894 27.7897C27.3742 28.7055 25.8906 28.7055 24.9753 27.7897L20.8318 23.6468C20.6029 23.4179 20.6029 23.0468 20.8319 22.818C21.3896 22.2607 20.9227 22.7275 22.9035 20.7467V20.7461L23.3176 20.3319Z",
  fill: "#6B5CE8"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarNoResult);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_no_result.8e07ad02a6534066841bfe4c28b59923.svg";